import BlockContent from '@sanity/block-content-to-react'
import React from 'react'

import { SanityBannerWithBody } from '../../../graphql/gatsby'
import { serializers } from './serializers'
import * as Styled from './styled'

export type BannerWithBodyProps = SanityBannerWithBody

const BannerWithBody: React.FC<BannerWithBodyProps> = ({
  body,
  textPosition,
  bannerTextColor,
  bannerBackgroundColor,
}) => {
  return (
    <Styled.Container
      backgroundColor={bannerBackgroundColor?.color}
      textColor={bannerTextColor?.color}
      textPosition={textPosition}
    >
      {body && <BlockContent blocks={body} serializers={serializers} />}
    </Styled.Container>
  )
}

export default BannerWithBody
